module.exports = __webpack_public_path__ + "static/media/banner2.d164fa35.jpg";